import { StepInfo } from 'apollo/types';
import PurchaseIntentForm from 'views/PurchaseIntentForm';
import OtherProcedures from 'views/OtherProcedures';
import Insurance from 'views/Insurance';

const carPurchaseSteps = [
  {
    title: 'Formulario de cotización',
    subtitle: 'Seleccione el tipo de flujo a realizar.',
    type: 'main',
    route: '/newPurchaseIntent',
    component: PurchaseIntentForm,
  },
  {
    title: 'Impuestos y trámites',
    subtitle: '',
    type: 'main',
    route: '/procedureSelection',
    component: OtherProcedures,
  },
  {
    title: 'Cotización de seguros',
    type: 'main',
    subtitle: '',
    route: '/insuranceSimulation',
    component: Insurance,
  },
];

const steps: StepInfo[] = carPurchaseSteps;

export default steps;
